import React from 'react';
import { Typography } from 'antd';
import { BOTS } from '@guuru/expert-common';
import Message from './Message';
import { Col } from '../IntentSelection/style';
import { SmartFormText } from './style';
import BotAnswer from './BotAnswer';
import MessageTooltip from '../../MessageTooltip';

const { Text } = Typography;

interface ChatRenderTextProps {
  message: {
    smartFormStyle?: boolean;
    author?: {
      id: string;
      __typename: string;
    };
    text?: string;
    i18n: string;
    type: string;
    createdAt: number;
  };
  tooltip?: boolean;
  children?: React.ReactNode;
  loading?: boolean;
  note?: boolean;
}

const ChatRenderText = function ({
  message,
  tooltip = true,
  children = null,
  loading = false,
  note = false,
}: ChatRenderTextProps) {
  const { smartFormStyle, author } = message;
  // eslint-disable-next-line no-underscore-dangle
  if (author?.__typename === 'UserAuthor' && smartFormStyle) {
    return (
      <Col xs={24} md={11} className="chat-content-intent-selection-message">
        <SmartFormText>{message.i18n}</SmartFormText>
      </Col>
    );
  }

  if (note) {
    return <Text style={{ textAlign: 'center' }}>{message.i18n}</Text>;
  }

  if (loading || message.type === 'typing' || message.type === 'connecting') {
    return (
      <Message message={{
        i18n: '',
        type: 'typing',
        createdAt: message.createdAt,
      }}
      />
    );
  }

  if (author?.id === BOTS.copilot.externalId) {
    return <BotAnswer message={message} />;
  }

  const msg = <Message message={message}>{children}</Message>;
  return tooltip
    ? <MessageTooltip message={message}>{msg}</MessageTooltip>
    : msg;
};

export default ChatRenderText;
